import { createFileRoute } from "@tanstack/react-router";
import AdminSurveyQuestionNewPage from "@/pages/admin/surveys/detail/questions/new";
import { useSurveysPermissions } from "@/pages/admin/surveys";

export const Route = createFileRoute("/app/admin/surveys/$surveyId/questions/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { surveyId } = Route.useParams();
  const { userCanEditAllSurveys, userCanViewAllSurveys } = useSurveysPermissions();

  return (
    <AdminSurveyQuestionNewPage
      surveyId={surveyId}
      userCanEditAllSurveys={userCanEditAllSurveys}
      userCanViewAllSurveys={userCanViewAllSurveys}
    />
  );
}
